// extracted by mini-css-extract-plugin
export default {"hr":"HorizontalRule-module_hr__G4YS3"};